import React, { useEffect, useState } from "react";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { CircularProgress } from "@mui/material";
import PasswordIcon from '@mui/icons-material/Password';
import axios from 'axios';
import apiLinks from '../../config/apiLinks.json';

const ChangePassword = () => {
    const { accessToken, logout , autoLogin} = useAuth();
    const navigate = useNavigate();

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");


    const [showNew, setShowNew] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        if (!accessToken) {
            autoLogin();
        }
    }, [accessToken]);

    const validateForm = () => {
        if (!oldPassword || !newPassword || !repeatPassword) {
            return "تمام فیلدها الزامی است";
        }

        if (newPassword.length < 6) {
            return "رمز جدید باید حداقل ۶ کاراکتر باشد";
        }
        if (oldPassword === newPassword) {
            return "رمز عبور جدید نمی‌تواند با رمز قبلی یکسان باشد";
        }
        if (newPassword !== repeatPassword) {
            return "تکرار رمز عبور مطابقت ندارد";
        }

        return null;
    };
    const getPasswordStrength = (password) => {
        if (!password) return { score: 0, label: "" };

        let score = 0;

        if (password.length >= 6) score++;
        if (/[A-Z]/.test(password)) score++;
        if (/[0-9]/.test(password)) score++;
        if (/[^A-Za-z0-9]/.test(password)) score++; 

        let label = "";
        if (score <= 1) label = "ضعیف";
        else if (score === 2) label = "متوسط";
        else if (score === 3) label = "قوی";
        else if (score >= 4) label = "خیلی قوی";

        return { score, label };
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }

        try {
            setLoading(true);
            console.log("oldpassword:", oldPassword)
            console.log("newPassword:", newPassword)
            console.log("repeatPassword:", repeatPassword)
            const res = await axios.post(
                    `${apiLinks.baseUrl}${apiLinks.User.UserChangePassword}?LastPassword=${oldPassword}&Password=${newPassword}&passwordRepeat=${repeatPassword}`,
                    null,
                    { withCredentials: true }
                );

            console.log("passwordChange", res.data)
               // await logout();
               // navigate("/login", { replace: true });
         

        } catch (err) {
            setError("خطا در تغییر رمز عبور");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container d-flex justify-content-center mt-5">
            <div
                className="card shadow-sm p-4 mt-5"
                style={{ width: "100%", maxWidth: "420px", borderRadius: "12px" }}
            >
                <h5 className="text-center mb-4 fw-bold">تغییر رمز عبور</h5>

                {error && (
                    <div className="alert alert-danger text-center p-2">
                        {error}
                    </div>
                )}

                {success && (
                    <div className="alert alert-success text-center p-2">
                        {success}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    {/* رمز فعلی */}
                    <div className="mb-3">
                        <label className="mb-1 text-muted fw-bold">
                            رمز عبور فعلی
                        </label>
                        <div className="position-relative">
                            <input
                                type={"password"}
                                className="form-control"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                            <span
                                className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                style={{ cursor: "pointer" }}
                            >
                                <PasswordIcon />
                            </span>
                        </div>
                    </div>

                    {/* رمز جدید */}
                    <div className="mb-3">
                        <label className="mb-1 text-muted fw-bold">
                            رمز عبور جدید
                        </label>
                        <small className="text-muted d-block mb-1">
                            رمز عبور شما باید حداقل 6 حرف باشد
                        </small>
                        <div className="position-relative">
                            <input
                                type={showNew ? "text" : "password"}
                                className="form-control"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <span
                                className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                onClick={() => setShowNew(!showNew)}
                                style={{ cursor: "pointer" }}
                            >
                                {showNew ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </span>
                        </div>
                        {/* Password Strength Bar */}
                        {newPassword && (
                            <div className="mt-2">
                                <div
                                    style={{
                                        height: "6px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e0e0e0",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: `${(getPasswordStrength(newPassword).score / 4) * 100}%`,
                                            height: "100%",
                                            borderRadius: "4px",
                                            transition: "width 0.3s",
                                            backgroundColor:
                                                getPasswordStrength(newPassword).score <= 1
                                                    ? "#f44336" 
                                                    : getPasswordStrength(newPassword).score === 2
                                                        ? "#ff9800" 
                                                        : getPasswordStrength(newPassword).score === 3
                                                            ? "#cddc39" 
                                                            : "#4caf50", 
                                        }}
                                    />
                                </div>
                                <small className="d-block mt-1 fw-bold">
                                    قدرت رمز: {getPasswordStrength(newPassword).label}
                                </small>
                            </div>
                        )}
                    </div>

                    {/* تکرار رمز جدید */}
                    <div className="mb-4">
                        <label className="mb-1 text-muted fw-bold">
                            تکرار رمز عبور جدید
                        </label>
                        <div className="position-relative">
                            <input
                                type={showRepeat ? "text" : "password"}
                                className="form-control"
                                value={repeatPassword}
                                onChange={(e) => setRepeatPassword(e.target.value)}
                            />
                            <span
                                className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                onClick={() => setShowRepeat(!showRepeat)}
                                style={{ cursor: "pointer" }}
                            >
                                {showRepeat ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-danger w-100 fw-bold d-flex justify-content-center align-items-center"
                        disabled={loading || success}
                    >
                        {loading ? (
                            <CircularProgress size={22} color="inherit" />
                        ) : (
                            "ثبت تغییرات"
                        )}
                    </button>

                    <div className="text-center mt-3">
                        <button
                            type="button"
                            className="btn btn-link text-muted text-decoration-none p-0"
                            onClick={() => navigate(-1)}
                        >
                            بازگشت
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
